/**
 * Local/E2E-only launch poll instrumentation.
 * Enabled only when window.__H05H_LAUNCH_POLL_TRACE__ is an object (Playwright addInitScript).
 * Never records URL values, emails, tokens, or raw payloads.
 */

function isTraceEnabled() {
  return typeof window !== 'undefined'
    && window.__H05H_LAUNCH_POLL_TRACE__
    && typeof window.__H05H_LAUNCH_POLL_TRACE__ === 'object';
}

/**
 * @param {{
 *   status?: string|null,
 *   public_ready?: boolean|null,
 *   progress_percent?: number|null,
 *   public_url?: string|null,
 *   poll_scheduled?: boolean,
 *   terminal?: boolean,
 *   state_applied?: boolean,
 *   cancelled?: boolean,
 * }} entry
 */
export function recordLaunchPollTrace(entry = {}) {
  if (!isTraceEnabled()) {
    return;
  }
  const bucket = window.__H05H_LAUNCH_POLL_TRACE__;
  if (!Array.isArray(bucket.events)) {
    bucket.events = [];
  }
  const publicUrl = typeof entry.public_url === 'string' ? entry.public_url.trim() : '';
  const progress = typeof entry.progress_percent === 'number' && Number.isFinite(entry.progress_percent)
    ? Math.max(0, Math.min(100, Math.round(entry.progress_percent)))
    : null;
  bucket.events.push({
    sequence: bucket.events.length + 1,
    status: typeof entry.status === 'string' ? entry.status : null,
    public_ready: entry.public_ready === true ? 1 : 0,
    progress_percent: progress,
    public_url_present: publicUrl !== '' ? 1 : 0,
    poll_scheduled: entry.poll_scheduled === true ? 1 : 0,
    terminal: entry.terminal === true ? 1 : 0,
    state_applied: entry.state_applied === true ? 1 : 0,
    cancelled: entry.cancelled === true ? 1 : 0,
    tenant_access_public_url: publicUrl !== '' ? 1 : 0,
  });
}

export default recordLaunchPollTrace;
